// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupVideoCall__container-f7770a {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(72px, auto) calc(var(--app-height) - 182px) minmax(110px, auto);
}

.GroupVideoCall__members-panel-container-d6aaf4 {
  width: 100%;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/GroupVideoCall/GroupVideoCall.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,0BAAA;EACA,0FAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: minmax(72px, auto) calc(var(--app-height) - 182px) minmax(110px, auto);\n}\n\n.members-panel-container {\n  width: 100%;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GroupVideoCall__container-f7770a`,
	"members-panel-container": `GroupVideoCall__members-panel-container-d6aaf4`,
	"membersPanelContainer": `GroupVideoCall__members-panel-container-d6aaf4`
};
module.exports = ___CSS_LOADER_EXPORT___;
